import theme from "../../../../../../../js/shared/new-theme";

import {
	gridGutter,
	fontSize18,
	fontSize16,
	fontSize14,
	gridGutter1q3,
	fontSize12,
	gridGutter1q1dot5
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const loadingStyle = `
	display: flex;
  justify-content: center;
  flex-direction: column;
	padding: 64px 0;
  width: 100%;
  
  strong, span {
    text-align: center;
  }

  span {
    margin: 16px;
  }
`;

export const boxFinishedOffer = `
	display: flex;
	flex-direction: column;
	padding: ${gridGutter1q3}px ${gridGutter1q1dot5}px 0;
	
	.layout {
		&--box {
			&-offer-registered {
				margin-bottom: ${gridGutter}px;
			}
			&-info-registered {
				margin-bottom: ${gridGutter}px;
			}
			&-info-finished-offer{
				margin-bottom: ${gridGutter}px;
			}
			&-button {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100%;
				font-size: ${fontSize18};
			}
		}


	.credit-card-input {
		position: relative;
	}
`;

export const boxUnsucccess = `
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
  padding: 0 24px;
  
	& strong {
		font-size: ${fontSize16};
		color: ${theme.palette.gray[700].value};
		text-align: center;
	}
	& span {
		font-size: ${fontSize14};
		color: ${theme.palette.gray[600].value};
		max-width: 480px;
		text-align: center;
		margin: 16px auto 48px;
	}
`;

export const boxOfferRegisteredStyle = `
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: center;
  padding: 0 0 0 3px;

  i {
    color: ${theme.palette.common.white}
  }

  .area-text {
    text-align: center;
    width: 80%;

    p {
      margin: 0;
    }
    span {
      font-weight: bold;
    }
    &--title {
      color: ${theme.palette.gray[800].value};
      font-size: ${fontSize16};
      font-weight: bold;
      margin-bottom: 4px !important;
    }
    &--link {
      font-size: ${fontSize16};
      color: ${theme.palette.gray[800].value};
      min-width: 90px;
      border: none;
      padding: 0px 10px;
      height: auto;
      font-size: 14px;
      min-width: 100px;
    }
  }

  .area-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    width: 35px;
    background-color: ${theme.palette.green[600].value};
    color: ${theme.palette.common.white};
    border-radius: 28px;
    font-size: ${fontSize16};
    margin: 0 ${gridGutter1q3 * 2}px ${gridGutter1q3 * 2}px;
  }

  .wrong-phone-area-icon {
    background-color: ${theme.palette.red[500].value};
  }

  .newoffers-callout{
    padding-top: 20px;
  }

  .mt-16 {
    margin-top: 16px
  }
`;

export const boxInfoRegisteredStyle = `
  display: flex;
  background-color: ${theme.palette.gray[100].value};
  border-radius: 8px;
  padding: ${gridGutter}px ${gridGutter1q1dot5}px ${gridGutter1q3}px;
  flex-direction: column;
  flex-wrap: wrap;

  .program-fidelity {
    font-size: ${fontSize16};
    margin-bottom: ${gridGutter1q1dot5}px;
    span {
      font-size: ${fontSize12};
    }
  }

  .title {
    margin: 0 0 4px;
  }

  .title-group {
    font-weight: bold;
    font-size: 16px;
    padding-bottom: ${gridGutter1q3}px;
  }

  .value {
    margin-bottom: ${gridGutter1q1dot5}px;
  }

  .resume-row {
    padding-bottom: ${gridGutter1q3}px;
    display: flex;
    flex-wrap: wrap;
  }

  .miles-row {
    padding-top: ${gridGutter1q1dot5}px;
    border-top: solid 2px ${theme.palette.gray[400].value};
    display: flex;
    flex-wrap: wrap;
  }

  .bank-row {
    padding-top: ${gridGutter}px !important;
    border-top: solid 2px ${theme.palette.gray[400].value};
    display: flex;
    flex-wrap: wrap;
    .bank-details {
      margin-bottom: ${gridGutter1q1dot5}px;
    }

    .values{
      font-weight: bold;
      margin: 0 0 14px;
      color: ${theme.palette.gray[800].value};
    }
  }

  .phoneLatam-row {
    padding-top: ${gridGutter}px !important;
    border-top: solid 2px ${theme.palette.gray[400].value};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    .values{
      font-weight: bold;
      margin: 0 0 14px;
      color: ${theme.palette.gray[800].value};
    }
  }

  .wrong-latam-phone {
    color: ${theme.palette.red[500].value}
  }

  .cc-row {
    padding-top: ${gridGutter}px !important;
    margin-top: ${gridGutter}px !important;
    border-top: solid 2px ${theme.palette.gray[400].value};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-content: flex-start;
    .cc-details {
      margin-bottom: ${gridGutter1q1dot5}px;
    }
  }

  .title-bf {
    font-size: 12px;
    color: ${theme.palette.gray[600].value};
    strong {
      display: block;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .box-price--tooltip {
    margin-left: 8px;
    display: flex;
    flex-wrap: wrap;
  }
  .area {
    &-infos {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-content: flex-start;

      .value{
        font-weight: bold;
        margin: 0 0 14px;
        color: ${theme.palette.gray[800].value};
      }
    }
    &-total-expected-gain {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .title {
        margin: 0;
      }
      .box-price {
        display:flex;
        &--tooltip {
          margin: 4px 0 0 8px;
        }

        &--currency {
          color: ${theme.palette.gray[800].value};
          font-size: ${fontSize18};
          font-weight: bold;
        }
      }
    }
  }
`;

export const boxInfoFinishedOfferStyle = `
  padding: 0 ${gridGutter1q3}px;
  .title {
    font-size: ${fontSize16};
    font-weight: bold;
    margin-bottom: ${gridGutter}px;
  }
`;
